import map from 'lodash/map'
import union from 'lodash/union'
import difference from 'lodash/difference'
import intersection from 'lodash/intersection'
import { GridSelectionModel } from '@mui/x-data-grid'

import { SelectAll } from 'types/SelectAll'
import { Meta, Participant, Queries } from 'types/Participants'

export const createSelectionModel = (
  selectAll: SelectAll,
  participants: Participant[],
  queries: Queries,
  selectedParticipantIDs: string[],
) => {
  let selectionModel: any = []
  const availableParticipants = createAvailableParticipant(participants)
  const isPageLevelParticipantsSelected =
    selectAll.allVisible && queries.page == selectAll.page
  // As all grid level participants are selected hence all available participants will be selected
  if (selectAll.all) {
    selectionModel = availableParticipants
  } else if (isPageLevelParticipantsSelected) {
    // As all page level participants are selected hence all participants from particular page should be selected
    selectionModel = selectedParticipantIDs
  } else if (selectedParticipantIDs.length > 0) {
    // Else always select already selected participants
    selectionModel = selectedParticipantIDs
  }
  return selectionModel
}

export const getFooterRowsSelected = (
  selectAll: SelectAll,
  queries: Queries,
  meta: Meta,
  selectedParticipantIDs: Participant[],
) => {
  let count
  if (selectAll.all) {
    // When all is true then count is equal to all participant within grid level
    count = meta.count
  } else if (selectedParticipantIDs.length || selectAll.allVisible) {
    // When allVisible is true then count is equal to all selected participant within page level
    // Else if selectedParticipantIDs exist, count is equal to selectedParticipantIDs.length
    count = selectedParticipantIDs.length
  }
  // Else send count
  return count
}

export const handelSelection = (
  participants: Participant[],
  participantIDs: GridSelectionModel,
  queries: Queries,
  setSelectAllObj: (param1: any) => void,
  onSelection: (param1: any) => void,
  selectedParticipantIDs: string[],
  selectAll: SelectAll,
) => {
  const availableParticipants = createAvailableParticipant(participants)
  const selectedParticipantsOnCurrentPage =
    getIntersectionOfCachedNSelectedParticipants(
      participantIDs,
      availableParticipants,
    )
  // Checking if all the participant on the current page are selected
  if (
    queries.per_page ===
    getIntersectionOfCachedNSelectedParticipants(
      participantIDs,
      availableParticipants,
    ).length
  ) {
    setSelectAllObj({
      allVisible: true,
      all: false,
      page: queries.page,
    })
    // When selectedParticipants overalap with available participants, that means we Cached participants greater than availableParticipants
    if (
      queries.per_page ===
      getIntersectionOfCachedNSelectedParticipants(
        selectedParticipantIDs,
        availableParticipants,
      ).length
    ) {
      onSelection(selectedParticipantIDs)
    } else {
      onSelection(availableParticipants)
    }
  } else {
    let overallSelectedParticipants = []
    if (
      selectAll.all === true &&
      selectedParticipantsOnCurrentPage.length < availableParticipants.length
    ) {
      overallSelectedParticipants = selectedParticipantsOnCurrentPage
    } else {
      overallSelectedParticipants = getUnionOfCachedNSelectedParticipants(
        selectedParticipantIDs,
        availableParticipants,
        participantIDs,
      )
    }
    // Else resetting the selectAll obj
    setSelectAllObj({
      allVisible: false,
      all: false,
      page: 0,
    })
    // Getting the actual list of selected participants and setting them for bulk tag

    onSelection(overallSelectedParticipants)
  }
}

export const createAvailableParticipant = (participants: Participant[]) =>
  map(participants, 'id')

// Here Cached participants are selected participants from other page where as selected participants are from current page

// Intersection of Cached and selected participants
export const getIntersectionOfCachedNSelectedParticipants = (
  participantIDs: GridSelectionModel,
  availableParticipants: string[],
) => intersection(participantIDs, availableParticipants)

// Union of Cached and selected participants
export const getUnionOfCachedNSelectedParticipants = (
  selectedParticipantIDs: string[],
  availableParticipants: string[],
  participantIDs: GridSelectionModel,
) =>
  union(
    getCachedParticipants(selectedParticipantIDs, availableParticipants),
    participantIDs,
  )

export const getCachedParticipants = (
  selectedParticipantIDs: string[],
  availableParticipants: string[],
) => difference(selectedParticipantIDs, availableParticipants)
